const acceptAllCookiesButton = document.querySelector("#accept-all-cookies");
const acceptNecessaryCookiesButton = document.querySelector(
  "#accept-necessary-cookies",
);
const cookieBanner = document.querySelector("#cookie-banner");

const closeCookieBanner = () => {
  document.cookie = "cookie_banner_handled=true;path=/;SameSite=Lax";
  cookieBanner?.remove();
};

if (acceptAllCookiesButton) {
  acceptAllCookiesButton.addEventListener("click", (e) => {
    e.preventDefault();

    document.cookie = "cookie_consent_given=true;path=/;SameSite=Lax";
    closeCookieBanner();
    document.location.reload();
  });
}

if (acceptNecessaryCookiesButton) {
  acceptNecessaryCookiesButton.addEventListener("click", (e) => {
    e.preventDefault();

    closeCookieBanner();
  });
}
